@if (hasDetails) {
  <div
    class="flex flex-wrap items-center gap-x-4 gap-y-1.5 ps-1 text-sm text-neutral-30">
    @if (absence()?.timeMax) {
      <span class="inline-flex items-center gap-1">
        <mat-icon class="qaroni-mat-icon-18 text-primary-50">timer</mat-icon>
        <ng-container i18n>Máximo</ng-container>
        <qaroni-absences-units-preview
          [unit]="absence().unit"
          [time]="absence().timeMax" />
      </span>
    }
    @if (absence()?.hasApproval) {
      <span class="inline-flex items-center gap-1">
        <mat-icon class="qaroni-mat-icon-18 text-primary-50">
          account_tree
        </mat-icon>
        <ng-container i18n>Requiere aprobación</ng-container>
      </span>
    }
  </div>
}
